import React, { useEffect, useState } from "react";
import Box from "src/components/common/Box";
import TextInput from "src/components/common/TextInput";
import Button from "src/components/common/Button";
import styled from "styled-components";
import AppLogo from "src/assets/images/appLogo.svg";
import { useErpLoginQuery, useMsErpLoginQuery } from "src/api/loginAPI";
import { encode as base64_encode } from "base-64";
import { getCookie, setCookie } from "src/utils/cookieUtil";
import { AccountInfo, PublicClientApplication } from "@azure/msal-browser";
import AzureAuthenticationButton from "src/azure/azure-authentication-component";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { MSAL_CONFIG } from "src/azure/azure-authentication-config";
import ErrorParser from "src/utils/jsonParser";
import Loading from "../Loading";
import CheckBox from "../../components/common/CheckBox";

const serverIp = process.env.REACT_APP_SERVER_IP;
const myMSALObj: PublicClientApplication = new PublicClientApplication(MSAL_CONFIG);

const Login = () => {
  const hash = location.hash;
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    id: "",
    password: "",
    query: true,
    errors: false,
  });

  const { id, password, query } = inputs;

  const [isWrongId, setWrongId] = useState(false);
  const [isWrongPw, setWrongPw] = useState(false);

  const changes = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, id } = e.target;
    setInputs({
      // inputs의 복사
      ...inputs,
      [id]: value,
    });
    setSkip(true);
  };

  // base-64 인코딩
  const idPass = id + ":::::" + password;
  const secretData = base64_encode(unescape(encodeURIComponent(idPass)));

  const [skip, setSkip] = useState(query);
  // api 데이터
  const { data, error, isLoading, isSuccess, isError } = useErpLoginQuery({ secret: secretData }, { skip });

  // useEffect(() => {
  //   const accessTokenRequest = {
  //     scopes: ["user.read"],
  //   };
  //   myMSALObj.acquireTokenRedirect(accessTokenRequest);
  // }, []);
  const [checked, setChecked] = useState(false);

  const loginBtnClick = () => {
    if (!checked) return alert("이용약관/사용자 정책 동의에 체크해주세요.");
    if (error) {
      alert("아이디를 다시 확인해 주세요");
    } else {
      setSkip(false);
    }
  };

  useEffect(() => {
    if (error) {
      // alert("정보가 잘못 되었습니다.");
      const errorString = JSON.stringify(error);
      const errorJson = JSON.parse(errorString);
      if (errorJson["data"].message === "PWD") {
        setWrongPw(true);
      }
      if (errorJson["data"].message === "ID") {
        setWrongId(true);
      }
    }
  }, [error]);
  // token 값 저장

  // ERP login
  // 매장, 업체 로그인
  useEffect(() => {
    if (isSuccess) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ ac_token: data?.data.accessToken, re_token: data?.data.refreshToken }));
      }
      setCookie("re_token", data?.data.refreshToken, { samSite: "strict" });
      setCookie("ac_token", data?.data.accessToken, { samSite: "strict" });

      location.href = "/home";
      // navigate("/home");
    }
  }, [isSuccess]);

  // MS 인증
  // const [currentUser, setCurrentUser] = useState<AccountInfo>();
  // authentication callback
  const [token, setToken] = useState<any>({
    ac_token: "",
    reflash: false,
  });
  const { ac_token, reflash } = token;

  const originOnToken = async (resultToken: string) => {
    setToken({
      ...token,
      ac_token: resultToken,
      reflash: true,
    });
  };

  const [msSkip, setMsSkip] = useState(true);

  useEffect(() => {
    if (reflash) {
      setToken({
        ...token,
        reflash: false,
      });
      setMsSkip(false);
    }
  }, [ac_token, reflash]);

  // ERP DB에서 정보 가지고 와서 token 받아옴
  const msLogin = useMsErpLoginQuery(ac_token, { skip: msSkip });

  // MStoken 값 저장
  useEffect(() => {
    if (msLogin.isSuccess) {
      setMsSkip(true);
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ ac_token: msLogin.data?.data.accessToken, re_token: data?.data.refreshToken }));
      }
      setCookie("re_token", msLogin.data?.data.refreshToken, { samSite: "strict" });
      setCookie("ac_token", msLogin.data?.data.accessToken, { samSite: "strict" });
      location.href = "/home";
    }
  }, [msLogin.isSuccess]);

  useEffect(() => {
    localStorage.removeItem("@BRAND");
  }, []);

  useEffect(() => {
    if (msLogin.isError) {
      const message = ErrorParser(msLogin.error);
      alert(message);
      location.href = "/";
      // navigate("/");
    }
  }, [msLogin.isError]);

  // let reMsLogin: any;
  // ms 로그인을 front-end에서 할때 로그인이 되는 대시 hash 태그를 주는 경우가 있다
  // 이때 다시 재 로그인을 시켜주기 위한 로직
  const reMsLogin = async (params: string) => {
    try {
      const response = await axios.post(
        serverIp + "/auth/login/ms",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + params,
          },
        },
      );
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ ac_token: response.data.data["accessToken"], re_token: response.data.data["refreshToken"] }));
      }
      setCookie("re_token", response.data.data["refreshToken"], { samSite: "strict" });
      setCookie("ac_token", response.data.data["accessToken"], { samSite: "strict" });
      location.href = "/home";
    } catch (error) {
      if (error) {
        if (String(error).indexOf("401") > -1) {
          alert("일치하는 아이디가 없습니다");
        } else {
          alert("서버 오류 발생");
        }
        location.href = "/";
        // navigate("/");
      }
    }
  };

  const reLoginOnToken = (resultToken: string) => {
    setToken({
      ...token,
      ac_token: resultToken,
      reflash: false,
    });
    if (resultToken) {
      reMsLogin(resultToken);
    }
  };

  // useEffect(() => {
  //   const azure = document.getElementById("authenticationButton");
  //   azure?.click();
  // },[])

  //  로그인 버튼을 프로그램에서 다시 눌러줌 (worst)
  if (hash.indexOf("#code") > -1) {
    // 이슈 여기에 있어야 #300 에러가 나서 errorBoundary에서 300을 잡고 Lodingbar를 만들어준다
    // 고처야함 (TODO)
    try {
      const t = AzureAuthenticationButton({ onAuthenticated: reLoginOnToken });
      t.props.children.props.onClick("loginRedirect");
    } catch (error) {
      console.log("MS Button compulsion Click", error);
    }
  }

  // #.1 로그인 버튼을 다시 누르도록 가이드를 주는 방법 (best)
  // useEffect(() => {
  //   if (hash.indexOf("#code") > -1) {
  //     alert("다시 로그인을 시도하시기 바랍니다.");
  //   }
  // }, []);

  function onKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key == "Enter") loginBtnClick();
  }

  const onCheckedHandle = () => {
    setChecked(!checked);
  };

  return (
    <>
      {msLogin.isLoading ? (
        <Loading />
      ) : (
        <>
          <LoginTitleWrap>
            <p className="title">안녕하세요.</p>
            <p className="sub-info">SMS와 동일한 계정을 사용합니다.</p>
          </LoginTitleWrap>
          <Box bg="#f4f4f4" pd="30px 15px">
            <TextInput type="text" id="id" name="id" label="아이디" onChange={changes} />
            {isWrongId && (
              <NoticeText>
                <p>일치하는 아이디가 없습니다.</p>
              </NoticeText>
            )}
            <TextInput type="password" id="password" name="password" label="비밀번호" onChange={changes} onKeyPress={onKeyPress} />
            {isWrongPw && (
              <NoticeText>
                <p>비밀번호가 일치하지 않습니다.</p>
                <p>지속 실패 시 본사 IT팀(02-520-6464)으로 연락 주세요.</p>
              </NoticeText>
            )}
            {/* <CheckBoxWrap>
              <CheckBox id="basic-checkbox1" checked={true} label="로그인 유지" />
            </CheckBoxWrap> */}
            {/* <div onClick={() => setSkip((prev) => !prev)}> */}
            <PolicyBox>
              <CheckBox id="check" type="round" label={"이용약관/사용자 정책 동의"} checked={checked} onChange={onCheckedHandle} />
              <Link to={"/privacy"}> (내용확인)</Link>
            </PolicyBox>
            <ButtonBox onClick={() => loginBtnClick()}>
              <Button variant="contained" br="round">
                로그인
              </Button>
            </ButtonBox>
          </Box>
          <div></div>
          <OptionButtonWrap>
            <Button variant="outlined" br="round">
              {/* <AzureAuthenticationButton onAuthenticated={onAuthenticated} /> */}
              <AzureAuthenticationButton onAuthenticated={originOnToken} />
            </Button>
          </OptionButtonWrap>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#94999f", fontSize: "13px" }}>
            <div>비밀번호 초기화 문의: 02-520-6464</div>
            <div>기타 문의: 담당 VMD</div>
          </div>
        </>
      )}
    </>
  );
};

const LoginTitleWrap = styled.div`
  padding: 80px 15px 90px;
  .title {
    padding-top: 88px;
    /* background: url(${AppLogo}) no-repeat left top; */
    font-size: 40px;
  }
  .sub-info {
    margin-top: 18px;
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 16px;
  }
`;

const ButtonBox = styled.div`
  margin-top: 30px;
`;
const PolicyBox = styled.div`
  margin-top: 15px;
`;

const OptionButtonWrap = styled.div`
  position: relative;
  padding: 60px 15px;
  ::before {
    content: "or";
    z-index: 10;
    position: absolute;
    left: 50%;
    top: 22px;
    transform: translate(-25px);
    display: inline-block;
    padding: 0 18px;
    background-color: #fff;
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 16px;
  }
  ::after {
    content: "";
    position: absolute;
    left: 15px;
    top: 30px;
    display: inline-block;
    width: calc(100% - 30px);
    height: 1px;
    background-color: ${({ theme }) => theme.color.lineSecondary};
  }
`;

const NoticeText = styled.div`
  margin: 5px 0 15px;
  > p {
    color: ${({ theme }) => theme.color.warning};
  }
`;

export default Login;
